module.exports = __webpack_public_path__ + "d78bedd00ad0fe70167a90dac15f624c.png";